<div id="dark" class="page-background" class="page-alignment">
    <div class="container-fluid">
        <nav ngbNav #nav="ngbNav" class="tabs-list">
            <ng-container ngbNavItem *ngIf="hasTechnicalAnalysis">
                <a ngbNavLink class="mb-2 mt-2 text-color-theme">
                    {{"TechnicalReport"|translate}}
                </a>
                <ng-template ngbNavContent>
                    <app-technical-reports></app-technical-reports>
                </ng-template>
            </ng-container>
        
            <ng-container ngbNavItem *ngIf="hasFundmentalAnalysis">
                <a ngbNavLink class="mb-2 mt-2 text-color-theme mx-3">
                    {{ "FundmentalReport" | translate }} 
                </a>
                <ng-template ngbNavContent>
                    <app-fundmental-report></app-fundmental-report>
                </ng-template>
            </ng-container>
        </nav>
        
        <div [ngbNavOutlet]="nav"></div>
    </div>
</div>



